import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

export default {
  data() {
    return {
      user: {},
      document: { subscriptions: [] },
      licenses: [],
      loading: true,
      error: "",
      loadError: "",
      loadVersion: 0,
      sessionStopped: false
    };
  },
  mounted() {
    this.unsubscribeAuth = firebase.auth().onAuthStateChanged(user => {
      this.user = user || {};
      return this.loadEnterprise();
    });
  },
  beforeDestroy() {
    this.sessionStopped = true;
    this.loadVersion++;
    if (this.unsubscribeAuth) this.unsubscribeAuth();
    this.clearLicenseBinding();
  },
  watch: {
    "$route.fullPath"() {
      this.loadEnterprise();
    }
  },
  methods: {
    clearLicenseBinding() {
      if (this.$firestoreRefs && this.$firestoreRefs.licenses) {
        this.$unbind("licenses");
      }
      this.licenses = [];
    },
    async loadEnterprise() {
      const version = ++this.loadVersion;
      const current = () => !this.sessionStopped && version === this.loadVersion;
      const { orgId, permalinkId } = this.$route.params;
      this.clearLicenseBinding();
      this.document = { subscriptions: [] };
      this.loadError = "";
      this.error = "";
      this.loading = !!this.user.uid;
      if (!this.user.uid) {
        document.title = "Hypermatic Enterprise Login";
        return;
      }
      try {
        const snapshot = await firebase.firestore().collection("enterprise_users").doc(orgId).get();
        if (!current()) return;
        if (!snapshot.exists) throw new Error("This enterprise account could not be found.");
        const organization = { ...snapshot.data(), id: snapshot.id };
        if (organization.isDeleted === true || organization.disabled === true) throw new Error("This enterprise account is disabled. Please contact support.");
        if (!Array.isArray(organization.subscriptions)) organization.subscriptions = [];
        if (permalinkId && !organization.subscriptions.some(sub => sub.permalink === permalinkId)) {
          throw new Error("This subscription could not be found. Please return to your enterprise dashboard.");
        }
        this.document = organization;
        if (permalinkId) {
          await this.$bind("licenses", firebase.firestore().collection("enterprise_keys")
            .where("org", "==", orgId).where("permalink", "==", permalinkId));
        }
      } catch (error) {
        if (!current()) return;
        this.clearLicenseBinding();
        this.loadError = error.code === "permission-denied"
          ? "You do not have access to this enterprise account. Please check the account link or contact support."
          : error.message || "Unable to load your enterprise account. Please try again.";
      } finally {
        if (current()) this.loading = false;
      }
    },
    async handleLogout() {
      try {
        await firebase.auth().signOut();
      } catch (error) {
        this.error = error.message || "Unable to sign out. Please try again.";
      }
    },
    handleError(error) {
      this.error = error.code === "auth/wrong-password"
        ? "Oops! That password isn't correct."
        : error.code === "auth/user-not-found"
          ? "Oops! This user wasn't found."
          : error.message || "Unable to sign in. Please try again.";
    }
  }
};
